export const goTo = (navigate: any, url: any) => {
  navigate(url);
};
